<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div>
    <v-progress-circular
      v-if="loading"
      indeterminate
    ></v-progress-circular>
    <div
      v-if="!loading && (production == null || production.length == 0 || (production.devices && production.devices.length == 0))"
      class="py-3"
    >
      {{ language.t('RoadProfiler.productionList.noProductionAvailable') }}
    </div>
    <div
      v-if="!loading && production != null && production.devices && production.devices.length > 0"
      class="py-3"
    >
      <b class="py-3 text-h5">
        {{ language.t('RoadProfiler.productionList.totalProduction') }}: {{ production.productionDuration }}
      </b>
      <div
        v-for="item in production.devices"
        :key="item.device_accountId"
      >
        <b class="py-3 text-h6">
          {{ item.device_name }} ({{ language.t('RoadProfiler.productionList.totalPeriod') }}:
          {{ item.productionDurationDevice }})
        </b>
        <div
          v-for="day in item.days"
          :key="day.date"
        >
          <b>
            {{ day.date }} ({{ language.t('RoadProfiler.productionList.totalDay') }}: {{ day.productionDurationDay }})
          </b>
          <v-data-table
            dense
            :items="day.production"
            :headers="headers"
            item-key="mcoperationperiodId"
            class="elevation-0 py-1"
            :hide-default-footer="true"
            disable-pagination
          >
            <template v-slot:[`item.device_accountId`]>
              {{ item.device_name }}
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    headers: [],
    data: null,
    production: null,
    loading: false,
    requestCancelToken: null,
  }),
  props: {},
  watch: {},
  mounted: function () { },
  methods: {
    getProduction(devices, task, start, end, callback = null) {
      this.getHeaders();
      var _this = this;
      this.loading = true;
      var data = { devices: devices, task: task, startdate: start, enddate: end };
      this.requestCancelToken = this.$axios.CancelToken.source();
      console.time("request production");
      this.requestProduction(data)
        .then((_) => {
          _this.loading = false;
          console.timeEnd("request production");
          if (callback) callback(true);
        })
        .catch((error) => {
          _this.loading = false;
          console.timeEnd("request production");
          if (callback) callback(false);
        });

      // this.$axios
      //   .get(route("api.production.rpr"), { params: data, cancelToken: this.requestCancelToken.token })
      //   .then((response) => {
      //     // TODO: check status
      //     console.log(response);
      //     _this.production = response.data;
      //     _this.loading = false;
      //     console.log(_this.production);
      //     console.timeEnd("request production");
      //     if (callback) callback(true);
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //     if (callback) callback(false);
      //   });
    },
    async requestProduction(data) {
      var _this = this;
      var res = await this.$axios.get(route("api.production.rpr.dates"), { params: data, cancelToken: this.requestCancelToken.token });
      _this.production = res.data;
      var devices = _this.production.devices;
      var promises = [];
      for (let i = 0; i < devices.length; i++) {
        for (let j = 0; j < devices[i].days.length; j++) {
          var promise = _this.$axios
            .get(route("api.production.rpr.simple"), {
              params: { device: devices[i].device_accountId, task: data.task, date: devices[i].days[j].date },
              cancelToken: _this.requestCancelToken.token,
            })
            .then((res) => {
              _this.production.devices[i].days[j].production = res.data.production;
            });
          promises.push(promise);
        }
      }
      var promises = await Promise.all(promises);
      console.log(res.data);

      var productionDuration = "0:00:00";
      for (let i = 0; i < _this.production.devices.length; i++) {
        var productionDurationDevice = "0:00:00";
        for (let j = 0; j < _this.production.devices[i].days.length; j++) {
          var productionDurationDay = "0:00:00";
          for (let k = 0; k < _this.production.devices[i].days[j].production.length; k++) {
            productionDurationDay = _this.sumTimes(productionDurationDay, _this.production.devices[i].days[j].production[k].duration);
            productionDurationDevice = _this.sumTimes(productionDurationDevice, _this.production.devices[i].days[j].production[k].duration);
            productionDuration = _this.sumTimes(productionDuration, _this.production.devices[i].days[j].production[k].duration);
          }
          _this.production.devices[i].days[j].productionDurationDay = productionDurationDay;
        }
        _this.production.devices[i].productionDurationDevice = productionDurationDevice;
      }
      _this.production.productionDuration = productionDuration;
    },
    sumTimes(time1, time2) {
      var totalSeconds = 0;
      var times = [time1, time2];
      times.forEach((time) => {
        var splitTime = time.split(":");
        totalSeconds += Number(splitTime[0]) * 3600;
        totalSeconds += Number(splitTime[1]) * 60;
        totalSeconds += Number(splitTime[2]);
      });
      var hours = Math.floor(totalSeconds / 3600);
      totalSeconds -= hours * 3600;
      var minutes = Math.floor(totalSeconds / 60);
      totalSeconds -= minutes * 60;

      var result = hours.toString() + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + totalSeconds).slice(-2);
      return result;
    },
    getHeaders() {
      this.headers = [
        {
          text: this.language.t("RoadProfiler.productionList." + "task"),
          align: "start",
          sortable: false,
          value: "taskDesignator",
          width: "20%",
        },
        {
          text: this.language.t("RoadProfiler.productionList." + "duration"),
          align: "start",
          sortable: false,
          value: "duration",
          width: "8%",
        },
        {
          text: this.language.t("RoadProfiler.productionList." + "start"),
          align: "start",
          sortable: false,
          value: "start_timestamp",
          width: "20%",
        },
        {
          text: this.language.t("RoadProfiler.productionList." + "end"),
          align: "start",
          sortable: false,
          value: "stop_timestamp",
          width: "20%",
        },
        {
          text: this.language.t("RoadProfiler.productionList." + "millingWitdh"),
          align: "start",
          sortable: false,
          value: "machineDrum",
          width: "7%",
        },
        {
          text: this.language.t("RoadProfiler.productionList." + "device"),
          align: "start",
          sortable: false,
          value: "device_accountId",
          width: "25%",
        },
      ];
    },
    empty() {
      console.log("Empty production table");
      this.loading = false;
      this.production = [];
      if (this.requestCancelToken) this.requestCancelToken.cancel();
    },
    isEmpty() {
      return !this.loading && (this.production == null || this.production.length == 0 || (this.production.devices && this.production.devices.length == 0));
    },
  },
  computed: {},
};
</script>
<style scoped></style>